module.exports = __webpack_public_path__ + "static/bowling-bfebfee8f7db59c21901c85195537b0c.png";